// src/utils/browserDetection.js

/**
 * ����Ƿ�Ϊ΢�����������
 * @returns {boolean} ��΢����������� true�����򷵻� false
 */
export function isWeixinBrowser() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger');
  }
  
  /**
   * ����Ƿ�Ϊ�ƶ��������
   * @returns {boolean} ���ƶ��˷��� true�����򷵻� false
   */
  export function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  
  /**
   * �ۺϼ�⣺�Ƿ�Ϊ�ƶ��˵�΢�����������
   * @returns {boolean} ���ƶ���΢����������� true�����򷵻� false
   */
  export function isMobileWeixin() {
    return isMobile() && isWeixinBrowser();
  }